import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {useParams} from "react-router";
import {PurchasingGroupStageSections} from "../constants/PurchasingGroupStageSections";
import useSnackbar from "hooks/useSnackbar";
import Tr from "translations/Translations";
import scheduleReloadTimeout from "../utils/scheduleReloadTimeout";
import UserService from "services/UserService";
import useDebouncedEffect from "hooks/useDebouncedEffect";
import PurchasingGroupStage from "../components/PurchasingGroupStage";

function PurchasingGroupStage1(
    {
        stageSections,
    }
) {
    const params = useParams();
    const groupId = params.id;
    const {enqueueInfoSnackbar} = useSnackbar();
    const reloadTimeout = useRef(0);

    useDebouncedEffect(() => {
        if (reloadTimeout.current) {
            clearTimeout(reloadTimeout.current);
            reloadTimeout.current = 0;
        }

        if (stageSections) {
            (async () => {
                const mainSection = stageSections[PurchasingGroupStageSections.STAGE_1_SECTION];
                if (mainSection && mainSection.schedule) {
                    const serverTime = await UserService.serverTime();
                    let newReloadTimeout = scheduleReloadTimeout(mainSection.schedule, serverTime);
                    if (newReloadTimeout) {
                        reloadTimeout.current = setTimeout(() => {
                            enqueueInfoSnackbar(Tr("purchasing_group_schedule_time_reached"))
                            getStage1Sections();
                        }, newReloadTimeout)
                    }
                }
            })()
        }
        // eslint-disable-next-line
    }, {timeout: 1000, ignoreInitialCall: true}, [stageSections]);

    const getStage1Sections = () => {
        PurchasingGroupSectionService.getStage1Sections(groupId);
    }
    useEffect(() => {
        getStage1Sections();
        return () => {
            if (reloadTimeout.current) {
                clearTimeout(reloadTimeout.current);
                reloadTimeout.current = 0;
            }
            PurchasingGroupSectionService.clearResources(PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID)
        }
        // eslint-disable-next-line
    }, [groupId])


    return (<PurchasingGroupStage mainSectionName={PurchasingGroupStageSections.STAGE_1_SECTION}/>)
}

PurchasingGroupStage1.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
}), {})(PurchasingGroupStage1);
